import { getDeviceId } from 'utils/deviceId'
import TentangKurikulumMerdekaApp from 'app/KurikulumMerdekaPage/pages/TentangKurikulumMerdeka'
import { Header } from 'app/KurikulumMerdekaPage/components/Header'

export function getServerSideProps(ctx) {
  return {
    props: {
      appDeviceID: getDeviceId(ctx),
    },
  }
}

export default function TentangKurikulumMerdekaPage({ appDeviceID }) {
  return <TentangKurikulumMerdekaApp appDeviceID={appDeviceID} />
}

TentangKurikulumMerdekaPage.layoutOpts = {
  hasBottomNav: false,
  hasHeader: true,
  header: Header,
}
